// DOM Elements 
const contractSelect = document.querySelector('[package-contract-period-select]');
const paymentSelect = document.querySelector('[package-payment-period-select]');
const buttonsOrder = document.querySelectorAll('[package-info-button-order]');
const priceSpans = document.querySelectorAll('[price-final]');
const priceDivs = document.querySelectorAll('[price-regular-div]');
const paymentRadios = document.querySelectorAll('[package-payment-period-radio]');


// Package Object
const PackageObject = {
    currency: packageData.currency,
    typeSlug: packageData.type_form_slug,
    kindSlug: packageData.kind_form_slug,
    type: packageData.item_category,
    kind: packageData.item_category2,
    price: parseInt(packageData.value),
    regularPrice: parseInt(packageData.value),
    contractPeriod: parseInt(packageData.contract_period),
    paymentPeriod: parseInt(packageData.payment_period),
    item_id: packageData.item_id,
    formBaseURL: packageData.formBaseURL,
    formULR: packageData.formURL,
    sales: packageData.sales,

    updateContractPeriod: function (value) {
        this.contractPeriod = value;
    },

    updatePaymentPeriod: function (value) {
        this.paymentPeriod = value;
    },

    updatePrice: function (value) {
        this.price = value;
    },

    resetPrice: function () {
        this.price = parseInt(packageData.value);
    },

    updateItemID: function (value) {
        this.item_id = value;
    },

    updateFormURL: function () {
        const kindSlug = this.kindSlug.toLowerCase().replace(/ /g, '-');
        const typeSlug = this.typeSlug.toLowerCase().replace(/ /g, '-');
        this.formULR = `${this.formBaseURL}${typeSlug}-${kindSlug}-${this.paymentPeriod}-${this.contractPeriod}`;

        this.updateItemID(`${typeSlug}-${kindSlug}-${this.paymentPeriod}-${this.contractPeriod}`);
    },

    get viewItemGTM() {
        return {
            currency: this.currency,
            value: this.price,
            items: [
                {
                    item_id: this.item_id,
                    item_name: `${this.kind} ${this.type}`,
                    currency: this.currency,
                    discount: null,
                    index: 0,
                    item_category: this.type,
                    item_category2: this.kind,
                    item_category3: this.contractPeriod,
                    item_category4: this.paymentPeriod,
                    price: this.price
                }
            ]
        };
    },
}


const sendViewItemData = () => {
    if (typeof gtag === 'function') {
        gtag("event", "view_item", PackageObject.viewItemGTM);
    } else {
        console.log(PackageObject.viewItemGTM)
    }
}


const updatePaymentPeriodSelect = () => {
    resetAllPaymentOptions();

    if (PackageObject.contractPeriod == 24) {
        if (PackageObject.paymentPeriod == 12) {
            changeToDefaultValue = true;
            PackageObject.updatePaymentPeriod(24);
        }
    } else if (PackageObject.contractPeriod == 12) {
        if (PackageObject.paymentPeriod == 24) {
            changeToDefaultValue = true;
            PackageObject.updatePaymentPeriod(12);
        }
    }

    const currentOptionSelected = document.querySelector(`[data-js-value="${PackageObject.contractPeriod}_${PackageObject.paymentPeriod}"]`);
    currentOptionSelected.checked = true;
    currentOptionSelected.closest('label').classList.add('selected');
}


const resetAllPaymentOptions = () => {
    // const payment_contract = `payment_contract_${PackageObject.contractPeriod}`;
    // paymentSelect.innerHTML = packageSelectOptions[payment_contract];
    paymentRadios.forEach(paymentRadio => {
        paymentRadio.checked = false;
        const label = paymentRadio.closest('label');
        label.classList.remove('selected');
    })
}


const calculatePrice = () => {
    const newPrice = Math.floor(PackageObject.regularPrice * PackageObject.sales[PackageObject.contractPeriod][PackageObject.paymentPeriod]);

    if (newPrice == PackageObject.regularPrice) {
        priceDivs.forEach(div => {
            div.style.display = 'none';
        });

        PackageObject.resetPrice();
    } else {
        priceDivs.forEach(div => {
            div.style.display = 'block';
        });

        PackageObject.updatePrice(newPrice);
    }

    priceSpans.forEach(span => {
        span.innerHTML = PackageObject.price + ' zł';
    })
};


const updateBtnURL = () => {
    PackageObject.updateFormURL();

    buttonsOrder.forEach(btn => {
        btn.href = PackageObject.formULR;
    })
}


const setQueryFromURL = url => {
    const queryArray = url.split('-');

    if (['12-1', '12-12', '24-1', '24-24'].includes(url)) {
        const contractQueryVal = (queryArray[0] === ('12' || '24')) ? parseInt(queryArray[0]) : PackageObject.contractPeriod;
        const periodQueryVal = (['1', '12', '24'].includes(queryArray[1])) ? parseInt(queryArray[1]) : PackageObject.paymentPeriod;

        PackageObject.updateContractPeriod(contractQueryVal);
        PackageObject.updatePaymentPeriod(periodQueryVal);

        updatePaymentPeriodSelect();

        contractSelect.value = contractQueryVal;
        contractSelect.dispatchEvent(new Event("change"));
    }
}



// Actions
if (window.location.hash) {
    setQueryFromURL(window.location.hash.substring(1));
}
calculatePrice();
updateBtnURL();
sendViewItemData();



if (contractSelect) {
    contractSelect.addEventListener("change", (e) => {
        const value = parseInt(e.target.value);
        PackageObject.updateContractPeriod(value);
        updatePaymentPeriodSelect();
        calculatePrice();
        updateBtnURL();
        sendViewItemData();
    });
}


if (paymentSelect) {
    paymentSelect.addEventListener("change", (e) => {
        const value = parseInt(e.target.value);
        PackageObject.updatePaymentPeriod(value);
        calculatePrice();
        updateBtnURL();
        sendViewItemData();
    });
}

if(paymentRadios.length > 0) {
    paymentRadios.forEach(paymentRadio => {
        paymentRadio.addEventListener('change', e => {
            const value = parseInt(e.target.value);
            PackageObject.updatePaymentPeriod(value);
            calculatePrice();
            updateBtnURL();
            sendViewItemData();

            paymentRadios.forEach(paymentRadio => {
                const label = paymentRadio.closest('label');
                label.classList.remove('selected');
            })
            paymentRadio.closest('label').classList.add('selected');
        })
    })
}


buttonsOrder.forEach(btn => {
    btn.addEventListener('click', () => {
        if (typeof gtag === 'function') {
            gtag("event", "add_to_cart", PackageObject.viewItemGTM);
        } else {
            console.log(PackageObject.viewItemGTM);
        }
    });
})